import Vue, { PropType } from 'vue';
import IconBase from '../icon';
import { IconProps, SVGJson } from '../utils/types';
import useSizeProps from '../utils/use-size-props';

const element: SVGJson = {"tag":"svg","attrs":{"fill":"none","viewBox":"0 0 24 24","width":"1em","height":"1em"},"children":[{"tag":"path","attrs":{"fill":"props.filledColor","d":"M3.15601 1L20.8441 1L20.4579 2.28706L20.4574 2.28891L20.4548 2.29765L20.4435 2.33618C20.4334 2.37108 20.4182 2.42417 20.3985 2.49424C20.3593 2.6344 20.3026 2.84237 20.2342 3.10842C20.0973 3.6408 19.914 4.40419 19.7306 5.32112C19.3625 7.16163 19 9.59072 19 12C19 14.4093 19.3625 16.8384 19.7306 18.6789C19.914 19.5958 20.0973 20.3592 20.2342 20.8916C20.3026 21.1576 20.3593 21.3656 20.3985 21.5058C20.4182 21.5758 20.4334 21.6289 20.4435 21.6638L20.4548 21.7023L20.4574 21.7111L20.4579 21.7127L20.8441 23L3.15601 23L3.54212 21.7129L3.54268 21.7111L3.54527 21.7023L3.55654 21.6638C3.56667 21.6289 3.58191 21.5758 3.60153 21.5058C3.64077 21.3656 3.69751 21.1576 3.76592 20.8916C3.90282 20.3592 4.08607 19.5958 4.26946 18.6789C4.63756 16.8384 5.00004 14.4093 5.00004 12C5.00004 9.59072 4.63756 7.16163 4.26946 5.32112C4.08607 4.40419 3.90282 3.6408 3.76592 3.10842C3.69751 2.84237 3.64077 2.6344 3.60153 2.49424C3.58191 2.42417 3.56667 2.37108 3.55654 2.33618L3.54527 2.29765L3.54268 2.28891L3.54221 2.28735L3.15601 1Z"}}]};

const PanoramaVerticalFilled = Vue.extend<IconProps>({
  name: 'PanoramaVerticalFilledIcon',
  functional: true,
  props: {
    size: {
      type: String,
    },
    onClick: {
      type: Function as PropType<IconProps['onClick']>,
    },
    fillColor: {
      type: [String, Array] as PropType<IconProps['fillColor']>,
    },
    strokeColor: {
      type: [String, Array] as PropType<IconProps['fillColor']>,
    },
    strokeWidth: {
      type: Number,
      default: 2
    }
  },
  render(createElement, context) {
    const { props, data } = context;
    const { size, ...otherProps } = props;

    const { className, style } = useSizeProps(size);
    const fullProps = {
      ...otherProps || {},
      id: 'panorama-vertical-filled',
      icon: element,
      staticClass: className,
      style,
    };
    data.props = fullProps;
    return createElement(IconBase, data);
  },
});

export default PanoramaVerticalFilled;
